import { useQuery } from '@tanstack/react-query';

import { getAssetByFamilyId } from '~/modules/artist-roster/lib/tracks';

interface TrackDetailsQueryProps {
  familyId?: string;
}

export const useTrackDetailsQuery = ({ familyId }: TrackDetailsQueryProps) => {
  return useQuery({
    queryKey: ['asset-by-family-id', familyId],
    queryFn: () => {
      return getAssetByFamilyId({ familyId: familyId! });
    },
    enabled: !!familyId,
  });
};
